import React, { Component, PropTypes } from 'react';
import NewCard from '../tc-ui/new-card';
import { Dialog, FlatButton, RaisedButton, TextField } from 'material-ui';
import json2csv from 'json2csv';
import Icon from '../tc-ui/icon';
import SectionHeading from '../tc-ui/section-heading';
import TCContactImport from '../invite-contacts/tc-contact-import';
import CSVUploadModal from './csv-upload-modal';

class TempConnectionsAdd extends Component {

  constructor() {
    super();
    this.state = {
      processedModal: false,
      uploadModal: false,
    };
  }

  onRequestClose = (modal) => {
    this.setState({ [modal]: false });
  };

  getProcessedModal = () => {
    let invalidRows;
    if (this.props.tempConnections.get('invalidRecords') &&
      this.props.tempConnections.get('invalidRecords').size) {
      invalidRows = this._rowMapper(this.props.tempConnections.get('invalidRecords'), true);
      const actions = [
        <FlatButton
          label="Reupload"
          type="button"
          secondary
          disableTouchRipple
          disableFocusRipple
          onClick={this.cancelCurrentCSVSelection}
        />,
      ];

      if (this.props.tempConnections.get('connections').size) {
        actions.push(<FlatButton
          label="Add Good Records"
          type="button"
          disableTouchRipple
          disableFocusRipple
          primary
          onClick={this.acceptCurrentCSVSelection}
        />);
      }

      return (
        <Dialog
          className="form-dialog"
          title="We Found Some Errors In Your File"
          actions={actions}
          open={this.props.tempConnections.get('processed')}
          ref="processedModal"
          onRequestClose={() => this.onRequestClose('processedModal')}
        >
          <div style={{ marginBottom: '16px', borderBottom: '2px solid #efefef' }}>
            We have listed the errors below. You can either add just the good records or try again and reupload the file.
          </div>
          <div style={{ maxHeight: '300px', overflow: 'auto' }}>
            <div style={{ borderBottom: '2px solid #efefef', width: '100%', lineHeight: '48px' }}>
              <div style={{ display: 'inline-block', fontSize: '14px', fontWeight: '600', color: 'rgb(54%, 54%, 54%)', width: '120px', 'marginRight': '16px' }}>Line Number</div>
              <div style={{ display: 'inline-block', fontSize: '14px', fontWeight: '600', color: 'rgb(54%, 54%, 54%)', width: '220px', 'marginRight': '16px' }}>Error</div>
            </div>
            {invalidRows.toArray()}
          </div>
        </Dialog>
      );
    }
  };

  getDynamicForm = () => {
    const form = this.getFormTemplateAndData();
    return (
      <div>
      <NewCard addConnections>
        <div>
          <div
            style={{ height: '48px', float: 'right', cursor: 'pointer' }}
            className="tc-card-header-title tc-new-card-header-title"
          >
            <Icon
              style={{ 'fontSize': '16px', 'lineHeight': '48px' }}
              className="tc-icon-insert-drive-file tc-icon-with-label"
              onClick={this.showUploadModal}
              label="UPLOAD"
            />
          </div>
        </div>
        <div
          className="tc-table-sub-header"
        >
          <div style={{ display: 'inline-block', fontSize: '12px', fontWeight: '600', color: 'rgb(54%, 54%, 54%)', width: '20%', 'marginRight': '16px' }}>Company Name</div>
          <div style={{ display: 'inline-block', fontSize: '12px', fontWeight: '600', color: 'rgb(54%, 54%, 54%)', width: '20%', 'marginRight': '16px' }}>Email</div>
          <div style={{ display: 'inline-block', fontSize: '12px', fontWeight: '600', color: 'rgb(54%, 54%, 54%)', width: '20%', 'marginRight': '16px' }}>First Name</div>
          <div style={{ display: 'inline-block', fontSize: '12px', fontWeight: '600', color: 'rgb(54%, 54%, 54%)', width: '20%', 'marginRight': '16px' }}>Last Name</div>
        </div>
        <div style={{ maxHeight: '300px', overflowX: 'auto' }}>
          {form.toArray()}
        </div>
      </NewCard>
      </div>
    );
  };

  getFormTemplateAndData = () => {
    let objectCount = 0;
    const size = this.props.tempConnections.get('connections') ? this.props.tempConnections.get('connections').size : 0;
    let icon;
    let closeIcon;
    return this.props.tempConnections.get('connections').map((connection, key) => {
      objectCount++;
      if (this.isValidInvitation(connection, objectCount, size)) {
        icon = (
          <div
            style={{
              lineHeight: '48px',
              display: 'inline-block',
              width: '24px',
              marginLeft: '5px',
            }}
          >
            <Icon
              className="tc-icon-add"
              style={{
                lineHeight: '18px',
                verticalAlign: 'middle',
                border: '2px solid green',
                borderRadius: '50%',
                fontSize: '18px',
              }}
              onClick={this._newConnection}
            />
          </div>
        );
      }

      if (size > 1) {
        closeIcon = <Icon className="tc-icon-delete2" onClick={() => this._removeInvitation(key)} />;
      }

      return (
        <div key={key} className="individual-invitation">
          <TextField
            style={{ fontSize: '12px', width: '20%', marginRight: '16px', verticalAlign: 'top' }}
            value={connection.get('companyName')}
            hintText="Optional"
            onChange={this._changeCollectionItemValue.bind(null, key, 'companyName')}
          />
          <TextField
            style={{ fontSize: '12px', width: '20%', marginRight: '16px', verticalAlign: 'top' }}
            value={connection.get('email')}
            hintText="Required"
            errorText={connection.get('hasFocusedEmail') && (() => this.getErrorText(connection, 'email'))()}
            onChange={this._changeCollectionItemValue.bind(null, key, 'email')}
          />
          <TextField
            style={{ fontSize: '12px', width: '20%', marginRight: '16px', verticalAlign: 'top' }}
            value={connection.get('firstName')}
            hintText="Optional"
            onChange={this._changeCollectionItemValue.bind(null, key, 'firstName')}
          />
          <TextField
            style={{ fontSize: '12px', width: '20%', marginRight: '16px', verticalAlign: 'top' }}
            value={connection.get('lastName')}
            hintText="Optional"
            onChange={this._changeCollectionItemValue.bind(null, key, 'lastName')}
          />
          {closeIcon}
          {icon}
        </div>
      );
    });
  };

  getErrorText = (invitation, type) => {
    if (type === 'email') {
      if (!invitation.get('email')) return 'Email is required';
      else if (!this.isValidEmail(invitation.get('email'))) return 'Must input a valid email';
    }
  };

  _rowMapper(rows, errors) {
    return rows.map(row => {
      let error = [];
      if (errors) {
        if (row.getIn([4, 'missingEmail'])) error.push('Missing Email');
        if (row.getIn([4, 'missingCompanyName'])) error.push('Missing Company Name');
        if (row.getIn([4, 'invalidEmail'])) {
          error.push('Invalid Email');
        }
        error = error.join(', ');
        return (
          <div style={{ borderBottom: '2px solid #efefef', width: '100%', lineHeight: '48px' }}>
            <div style={{ display: 'inline-block', width: '120px', color: 'rgb(54%, 54%, 54%)' }} className="modalErrorLine">{row.getIn([4, 'line'])}</div>
            <div style={{ display: 'inline-block', width: '512px', marginLeft: '16px', color: 'rgb(54%, 54%, 54%)' }} className="modalError">{error}</div>
          </div>
        );
      }
      const rowToDisplay = row.toArray().map((item, index) => {
        let classes = 'csvItem';
        if (index === 0 || index === 1) classes += ' longItem';
        return <div className={classes}> {item} </div>;
      });
      return (
       <div className="csvRow"> {rowToDisplay} </div>
      );
    });
  }

  showUploadModal = () => {
    this.setState({ uploadModal: true });
  };


  _changeCollectionItemValue = (mapKey, valueKey, event) => {
    const value = event.target.value;
    this.props.changeCollectionItemValue(mapKey, valueKey, value);
  };

  sendConnections = (connections) => {
    const { history, sendTempConnections } = this.props;
    sendTempConnections(connections)
      .then((res) => {
        if (res.payload.allProcessed) history.push('/connections/add-connections/send');
      });
  };

  _newConnection = () => {
    this.props.addAnotherConnection();
  };

  _removeInvitation = (mapKey) => {
    this.props.removeInvitation(mapKey);
  };

  _cancelCSVHeaderSelect = () => {
    if (this.props.tempConnections.get('persistedFromServer')) this.props.deleteTempConnections();
    this.props.cancelCSVHeaderSelection();
  };

  isValidInvitation = (connection, objectCount, size) => {
    return Boolean(objectCount === size &&
    connection.get('email') &&
    this.isValidEmail(connection.get('email')));
  };

  isValidEmail(email) {
    const filter = /^\s*[\w\-\+_]+(\.[\w\-\+_]+)*\@[\w\-\+_]+\.[\w\-\+_]+(\.[\w\-\+_]+)*\s*$/;
    return String(email).search(filter) !== -1;
  }

  acceptCurrentCSVSelection = () => {
    this.props.acceptCurrentCSVSelection();
    this.setState({ processedModal: false });
  };

  cancelCurrentCSVSelection = () => {
    this.props.cancelCurrentCSVSelection();
    this.setState({ processedModal: false });
  };

  afterSubmitContacts = (contacts) => {
    this.props.convertFromCSV(json2csv({ data: contacts.map((contact) => ({ email: contact.__selectedMail__, firstName: contact.first_name, lastName: contact.last_name })), fields: ['companyName', 'email', 'firstName', 'lastName'], hasCSVColumnTitle: false }));
  }

  render() {
    const content = this.getDynamicForm();
    const processedErrorModal = this.getProcessedModal();
    const button = this.props.tempConnections.get('processing') ?
      (
        <RaisedButton
          style={{ float: 'right' }}
          type="button"
          className={'temp-connection-next-button loader'}
          disableTouchRipple
          disableFocusRipple
          disabled
          primary={false}
          label=""
        />
      ) : (
        <RaisedButton
          style={{ float: 'right' }}
          label="Next"
          type="button"
          disableTouchRipple
          disableFocusRipple
          disabled={!this.props.tempConnections.get('allRecordsValid') || this.props.tempConnections.get('processing')}
          primary={this.props.tempConnections.get('allRecordsValid') && !this.props.tempConnections.get('processing')}
          onClick={() => this.sendConnections(this.props.tempConnections.get('connections').toArray().map((item) => {
            const itemToObj = item.toObject();
            if (!itemToObj.firstName) itemToObj.firstName = '';
            if (!itemToObj.lastName) itemToObj.lastName = '';
            return itemToObj;
          }))}
        />
      );

    return (
      <div>
        <SectionHeading
          title="Add Connections"
          subtitle="Invite your existing partners by entering their contact information below or upload a file. Email is required."
          style={{ marginTop: '64px' }}
        />
        {processedErrorModal}
        <div style={{ width: 'calc(100% * (2/3))', display: 'inline-block', verticalAlign: 'top' }}>
          {content}
          <div style={{ marginTop: '24px' }}>
            <RaisedButton
              label={'Reset'}
              type="button"
              secondary
              disableTouchRipple
              disableFocusRipple
              onClick={this._cancelCSVHeaderSelect}
            />
            {button}
          </div>
        </div>
        <div style={{ width: 'calc(100% * (1/3))', display: 'inline-block', verticalAlign: 'top', paddingLeft: '50px' }}>
          <SectionHeading
            title="Other ways to invite"
            subtitle="Invite your existing contacts"
          />
        <TCContactImport afterSubmitContacts={this.afterSubmitContacts} />
        </div>
        <CSVUploadModal
          open={this.state.uploadModal}
          onRequestClose={this.onRequestClose}
          reset={this._cancelCSVHeaderSelect}
        />
        <br/>
        <br/>
      </div>
    );
  }
}

TempConnectionsAdd.propTypes = {
  cancelCurrentCSVSelection: PropTypes.func,
  acceptCurrentCSVSelection: PropTypes.func,
  convertFromCSV: PropTypes.func,
  changeCollectionItemValue: PropTypes.func,
  sendTempConnections: PropTypes.func,
  history: PropTypes.object,
  addAnotherConnection: PropTypes.func,
  removeInvitation: PropTypes.func,
  deleteTempConnections: PropTypes.func,
  cancelCSVHeaderSelection: PropTypes.func,
  tempConnections: PropTypes.object,
};

export default TempConnectionsAdd;



// WEBPACK FOOTER //
// ./src/app/components/temp-connections/temp-connections-add.jsx